export default [
	{
		"val": "AF Afghanistan Afghánistán",
		"nazev": "Afghánistán",
		"kod": "AF"
	},
	{
		"val": "AL Albanie Albánie",
		"nazev": "Albánie",
		"kod": "AL"
	},
	{
		"val": "AQ Antarktida Antarktida",
		"nazev": "Antarktida",
		"kod": "AQ"
	},
	{
		"val": "DZ Alzirsko Alžírsko",
		"nazev": "Alžírsko",
		"kod": "DZ"
	},
	{
		"val": "AS Americka Samoa Americká Samoa",
		"nazev": "Americká Samoa",
		"kod": "AS"
	},
	{
		"val": "AD Andorra Andorra",
		"nazev": "Andorra",
		"kod": "AD"
	},
	{
		"val": "AO Angola Angola",
		"nazev": "Angola",
		"kod": "AO"
	},
	{
		"val": "AG Antigua a Barbuda Antigua a Barbuda",
		"nazev": "Antigua a Barbuda",
		"kod": "AG"
	},
	{
		"val": "AZ Azerbajdzan Ázerbájdžán",
		"nazev": "Ázerbájdžán",
		"kod": "AZ"
	},
	{
		"val": "AR Argentina Argentina",
		"nazev": "Argentina",
		"kod": "AR"
	},
	{
		"val": "AU Australie Austrálie",
		"nazev": "Austrálie",
		"kod": "AU"
	},
	{
		"val": "AT Rakousko Rakousko",
		"nazev": "Rakousko",
		"kod": "AT"
	},
	{
		"val": "BS Bahamy Bahamy",
		"nazev": "Bahamy",
		"kod": "BS"
	},
	{
		"val": "BH Bahrajn Bahrajn",
		"nazev": "Bahrajn",
		"kod": "BH"
	},
	{
		"val": "BD Banglades Bangladéš",
		"nazev": "Bangladéš",
		"kod": "BD"
	},
	{
		"val": "AM Armenie Arménie",
		"nazev": "Arménie",
		"kod": "AM"
	},
	{
		"val": "BB Barbados Barbados",
		"nazev": "Barbados",
		"kod": "BB"
	},
	{
		"val": "BE Belgie Belgie",
		"nazev": "Belgie",
		"kod": "BE"
	},
	{
		"val": "BM Bermudy Bermudy",
		"nazev": "Bermudy",
		"kod": "BM"
	},
	{
		"val": "BT Bhutan Bhútán",
		"nazev": "Bhútán",
		"kod": "BT"
	},
	{
		"val": "BO Mnohonarodni stat Bolivie Mnohonárodní stát Bolívie",
		"nazev": "Mnohonárodní stát Bolívie",
		"kod": "BO"
	},
	{
		"val": "BA Bosna a Hercegovina Bosna a Hercegovina",
		"nazev": "Bosna a Hercegovina",
		"kod": "BA"
	},
	{
		"val": "BW Botswana Botswana",
		"nazev": "Botswana",
		"kod": "BW"
	},
	{
		"val": "BV Bouvetuv ostrov Bouvetův ostrov",
		"nazev": "Bouvetův ostrov",
		"kod": "BV"
	},
	{
		"val": "BR Brazilie Brazílie",
		"nazev": "Brazílie",
		"kod": "BR"
	},
	{
		"val": "BZ Belize Belize",
		"nazev": "Belize",
		"kod": "BZ"
	},
	{
		"val": "IO Britske indickooceanske uzemi Britské indickooceánské území",
		"nazev": "Britské indickooceánské území",
		"kod": "IO"
	},
	{
		"val": "SB Salomounovy ostrovy Šalomounovy ostrovy",
		"nazev": "Šalomounovy ostrovy",
		"kod": "SB"
	},
	{
		"val": "VG Britske Panenske ostrovy Britské Panenské ostrovy",
		"nazev": "Britské Panenské ostrovy",
		"kod": "VG"
	},
	{
		"val": "XK Kosovo Kosovo",
		"nazev": "Kosovo",
		"kod": "XK"
	},
	{
		"val": "BN Brunej Darussalam Brunej Darussalam",
		"nazev": "Brunej Darussalam",
		"kod": "BN"
	},
	{
		"val": "BG Bulharsko Bulharsko",
		"nazev": "Bulharsko",
		"kod": "BG"
	},
	{
		"val": "MM Myanma Myanma",
		"nazev": "Myanma",
		"kod": "MM"
	},
	{
		"val": "BI Burundi Burundi",
		"nazev": "Burundi",
		"kod": "BI"
	},
	{
		"val": "BY Belorusko Bělorusko",
		"nazev": "Bělorusko",
		"kod": "BY"
	},
	{
		"val": "KH Kambodza Kambodža",
		"nazev": "Kambodža",
		"kod": "KH"
	},
	{
		"val": "CM Kamerun Kamerun",
		"nazev": "Kamerun",
		"kod": "CM"
	},
	{
		"val": "CA Kanada Kanada",
		"nazev": "Kanada",
		"kod": "CA"
	},
	{
		"val": "CV Kapverdy Kapverdy",
		"nazev": "Kapverdy",
		"kod": "CV"
	},
	{
		"val": "KY Kajmanske ostrovy Kajmanské ostrovy",
		"nazev": "Kajmanské ostrovy",
		"kod": "KY"
	},
	{
		"val": "CF Stredoafricka republika Středoafrická republika",
		"nazev": "Středoafrická republika",
		"kod": "CF"
	},
	{
		"val": "LK Sri Lanka Srí Lanka",
		"nazev": "Srí Lanka",
		"kod": "LK"
	},
	{
		"val": "TD Cad Čad",
		"nazev": "Čad",
		"kod": "TD"
	},
	{
		"val": "CL Chile Chile",
		"nazev": "Chile",
		"kod": "CL"
	},
	{
		"val": "CN Cina Čína",
		"nazev": "Čína",
		"kod": "CN"
	},
	{
		"val": "TW Tchaj-wan (cinska provincie) Tchaj-wan (čínská provincie)",
		"nazev": "Tchaj-wan (čínská provincie)",
		"kod": "TW"
	},
	{
		"val": "CX Vanocni ostrov Vánoční ostrov",
		"nazev": "Vánoční ostrov",
		"kod": "CX"
	},
	{
		"val": "CC Kokosove (Keelingovy) ostrovy Kokosové (Keelingovy) ostrovy",
		"nazev": "Kokosové (Keelingovy) ostrovy",
		"kod": "CC"
	},
	{
		"val": "CO Kolumbie Kolumbie",
		"nazev": "Kolumbie",
		"kod": "CO"
	},
	{
		"val": "KM Komory Komory",
		"nazev": "Komory",
		"kod": "KM"
	},
	{
		"val": "YT Mayotte Mayotte",
		"nazev": "Mayotte",
		"kod": "YT"
	},
	{
		"val": "CG Kongo, republika Kongo, republika",
		"nazev": "Kongo, republika",
		"kod": "CG"
	},
	{
		"val": "CD Kongo, demokraticka republika Kongo, demokratická republika",
		"nazev": "Kongo, demokratická republika",
		"kod": "CD"
	},
	{
		"val": "CK Cookovy ostrovy Cookovy ostrovy",
		"nazev": "Cookovy ostrovy",
		"kod": "CK"
	},
	{
		"val": "CR Kostarika Kostarika",
		"nazev": "Kostarika",
		"kod": "CR"
	},
	{
		"val": "HR Chorvatsko Chorvatsko",
		"nazev": "Chorvatsko",
		"kod": "HR"
	},
	{
		"val": "CU Kuba Kuba",
		"nazev": "Kuba",
		"kod": "CU"
	},
	{
		"val": "CY Kypr Kypr",
		"nazev": "Kypr",
		"kod": "CY"
	},
	{
		"val": "BJ Benin Benin",
		"nazev": "Benin",
		"kod": "BJ"
	},
	{
		"val": "DK Dansko Dánsko",
		"nazev": "Dánsko",
		"kod": "DK"
	},
	{
		"val": "DM Dominika Dominika",
		"nazev": "Dominika",
		"kod": "DM"
	},
	{
		"val": "DO Dominikanska republika Dominikánská republika",
		"nazev": "Dominikánská republika",
		"kod": "DO"
	},
	{
		"val": "EC Ekvador Ekvádor",
		"nazev": "Ekvádor",
		"kod": "EC"
	},
	{
		"val": "SV Salvador Salvador",
		"nazev": "Salvador",
		"kod": "SV"
	},
	{
		"val": "GQ Rovnikova Guinea Rovníková Guinea",
		"nazev": "Rovníková Guinea",
		"kod": "GQ"
	},
	{
		"val": "ET Etiopie Etiopie",
		"nazev": "Etiopie",
		"kod": "ET"
	},
	{
		"val": "ER Eritrea Eritrea",
		"nazev": "Eritrea",
		"kod": "ER"
	},
	{
		"val": "EE Estonsko Estonsko",
		"nazev": "Estonsko",
		"kod": "EE"
	},
	{
		"val": "FO Faerske ostrovy Faerské ostrovy",
		"nazev": "Faerské ostrovy",
		"kod": "FO"
	},
	{
		"val": "FK Falklandske ostrovy (Malviny) Falklandské ostrovy (Malvíny)",
		"nazev": "Falklandské ostrovy (Malvíny)",
		"kod": "FK"
	},
	{
		"val": "GS Jizni Georgie a Jizni Sandwichovy ostrovy Jižní Georgie a Jižní Sandwichovy ostrovy",
		"nazev": "Jižní Georgie a Jižní Sandwichovy ostrovy",
		"kod": "GS"
	},
	{
		"val": "FJ Fidzi Fidži",
		"nazev": "Fidži",
		"kod": "FJ"
	},
	{
		"val": "FI Finsko Finsko",
		"nazev": "Finsko",
		"kod": "FI"
	},
	{
		"val": "AX Alandske ostrovy Alandské ostrovy",
		"nazev": "Alandské ostrovy",
		"kod": "AX"
	},
	{
		"val": "FR Francie Francie",
		"nazev": "Francie",
		"kod": "FR"
	},
	{
		"val": "GF Francouzska Guyana Francouzská Guyana",
		"nazev": "Francouzská Guyana",
		"kod": "GF"
	},
	{
		"val": "PF Francouzska Polynesie Francouzská Polynésie",
		"nazev": "Francouzská Polynésie",
		"kod": "PF"
	},
	{
		"val": "TF Francouzska jizni uzemi Francouzská jižní území",
		"nazev": "Francouzská jižní území",
		"kod": "TF"
	},
	{
		"val": "DJ Dzibutsko Džibutsko",
		"nazev": "Džibutsko",
		"kod": "DJ"
	},
	{
		"val": "GA Gabon Gabon",
		"nazev": "Gabon",
		"kod": "GA"
	},
	{
		"val": "GE Gruzie Gruzie",
		"nazev": "Gruzie",
		"kod": "GE"
	},
	{
		"val": "GM Gambie Gambie",
		"nazev": "Gambie",
		"kod": "GM"
	},
	{
		"val": "PS Palestinske uzemi (okupovane) Palestinské území (okupované)",
		"nazev": "Palestinské území (okupované)",
		"kod": "PS"
	},
	{
		"val": "DE Nemecko Německo",
		"nazev": "Německo",
		"kod": "DE"
	},
	{
		"val": "GH Ghana Ghana",
		"nazev": "Ghana",
		"kod": "GH"
	},
	{
		"val": "GI Gibraltar Gibraltar",
		"nazev": "Gibraltar",
		"kod": "GI"
	},
	{
		"val": "KI Kiribati Kiribati",
		"nazev": "Kiribati",
		"kod": "KI"
	},
	{
		"val": "GR Recko Řecko",
		"nazev": "Řecko",
		"kod": "GR"
	},
	{
		"val": "GL Gronsko Grónsko",
		"nazev": "Grónsko",
		"kod": "GL"
	},
	{
		"val": "GD Grenada Grenada",
		"nazev": "Grenada",
		"kod": "GD"
	},
	{
		"val": "GP Guadeloupe Guadeloupe",
		"nazev": "Guadeloupe",
		"kod": "GP"
	},
	{
		"val": "GU Guam Guam",
		"nazev": "Guam",
		"kod": "GU"
	},
	{
		"val": "GT Guatemala Guatemala",
		"nazev": "Guatemala",
		"kod": "GT"
	},
	{
		"val": "GN Guinea Guinea",
		"nazev": "Guinea",
		"kod": "GN"
	},
	{
		"val": "GY Guyana Guyana",
		"nazev": "Guyana",
		"kod": "GY"
	},
	{
		"val": "HT Haiti Haiti",
		"nazev": "Haiti",
		"kod": "HT"
	},
	{
		"val": "HM Hearduv ostrov a McDonaldovy ostrovy Heardův ostrov a McDonaldovy ostrovy",
		"nazev": "Heardův ostrov a McDonaldovy ostrovy",
		"kod": "HM"
	},
	{
		"val": "VA Svaty stolec (Vatikansky mestsky stat) Svatý stolec (Vatikánský městský stát)",
		"nazev": "Svatý stolec (Vatikánský městský stát)",
		"kod": "VA"
	},
	{
		"val": "HN Honduras Honduras",
		"nazev": "Honduras",
		"kod": "HN"
	},
	{
		"val": "HK Hongkong Hongkong",
		"nazev": "Hongkong",
		"kod": "HK"
	},
	{
		"val": "HU Madarsko Maďarsko",
		"nazev": "Maďarsko",
		"kod": "HU"
	},
	{
		"val": "IS Island Island",
		"nazev": "Island",
		"kod": "IS"
	},
	{
		"val": "IN Indie Indie",
		"nazev": "Indie",
		"kod": "IN"
	},
	{
		"val": "ID Indonesie Indonésie",
		"nazev": "Indonésie",
		"kod": "ID"
	},
	{
		"val": "IR Iran (islamska republika) Írán (islámská republika)",
		"nazev": "Írán (islámská republika)",
		"kod": "IR"
	},
	{
		"val": "IQ Irak Irák",
		"nazev": "Irák",
		"kod": "IQ"
	},
	{
		"val": "IE Irsko Irsko",
		"nazev": "Irsko",
		"kod": "IE"
	},
	{
		"val": "IL Izrael Izrael",
		"nazev": "Izrael",
		"kod": "IL"
	},
	{
		"val": "IT Italie Itálie",
		"nazev": "Itálie",
		"kod": "IT"
	},
	{
		"val": "CI Pobrezi Slonoviny Pobřeží Slonoviny",
		"nazev": "Pobřeží Slonoviny",
		"kod": "CI"
	},
	{
		"val": "JM Jamajka Jamajka",
		"nazev": "Jamajka",
		"kod": "JM"
	},
	{
		"val": "JP Japonsko Japonsko",
		"nazev": "Japonsko",
		"kod": "JP"
	},
	{
		"val": "KZ Kazachstan Kazachstán",
		"nazev": "Kazachstán",
		"kod": "KZ"
	},
	{
		"val": "JO Jordansko Jordánsko",
		"nazev": "Jordánsko",
		"kod": "JO"
	},
	{
		"val": "KE Kena Keňa",
		"nazev": "Keňa",
		"kod": "KE"
	},
	{
		"val": "KP Korea, lidove demokraticka republika Korea, lidově demokratická republika",
		"nazev": "Korea, lidově demokratická republika",
		"kod": "KP"
	},
	{
		"val": "KR Korejska republika Korejská republika",
		"nazev": "Korejská republika",
		"kod": "KR"
	},
	{
		"val": "KW Kuvajt Kuvajt",
		"nazev": "Kuvajt",
		"kod": "KW"
	},
	{
		"val": "KG Kyrgyzstan Kyrgyzstán",
		"nazev": "Kyrgyzstán",
		"kod": "KG"
	},
	{
		"val": "LA Laoska lidove demokraticka republika Laoská lidově demokratická republika",
		"nazev": "Laoská lidově demokratická republika",
		"kod": "LA"
	},
	{
		"val": "LB Libanon Libanon",
		"nazev": "Libanon",
		"kod": "LB"
	},
	{
		"val": "LS Lesotho Lesotho",
		"nazev": "Lesotho",
		"kod": "LS"
	},
	{
		"val": "LV Lotyssko Lotyšsko",
		"nazev": "Lotyšsko",
		"kod": "LV"
	},
	{
		"val": "LR Liberie Libérie",
		"nazev": "Libérie",
		"kod": "LR"
	},
	{
		"val": "LY Libye Libye",
		"nazev": "Libye",
		"kod": "LY"
	},
	{
		"val": "LI Lichtenstejnsko Lichtenštejnsko",
		"nazev": "Lichtenštejnsko",
		"kod": "LI"
	},
	{
		"val": "LT Litva Litva",
		"nazev": "Litva",
		"kod": "LT"
	},
	{
		"val": "LU Lucembursko Lucembursko",
		"nazev": "Lucembursko",
		"kod": "LU"
	},
	{
		"val": "MO Macao Macao",
		"nazev": "Macao",
		"kod": "MO"
	},
	{
		"val": "MG Madagaskar Madagaskar",
		"nazev": "Madagaskar",
		"kod": "MG"
	},
	{
		"val": "MW Malawi Malawi",
		"nazev": "Malawi",
		"kod": "MW"
	},
	{
		"val": "MY Malajsie Malajsie",
		"nazev": "Malajsie",
		"kod": "MY"
	},
	{
		"val": "MV Maledivy Maledivy",
		"nazev": "Maledivy",
		"kod": "MV"
	},
	{
		"val": "ML Mali Mali",
		"nazev": "Mali",
		"kod": "ML"
	},
	{
		"val": "MT Malta Malta",
		"nazev": "Malta",
		"kod": "MT"
	},
	{
		"val": "MQ Martinik Martinik",
		"nazev": "Martinik",
		"kod": "MQ"
	},
	{
		"val": "MR Mauritanie Mauritánie",
		"nazev": "Mauritánie",
		"kod": "MR"
	},
	{
		"val": "MU Mauricius Mauricius",
		"nazev": "Mauricius",
		"kod": "MU"
	},
	{
		"val": "MX Mexiko Mexiko",
		"nazev": "Mexiko",
		"kod": "MX"
	},
	{
		"val": "MC Monako Monako",
		"nazev": "Monako",
		"kod": "MC"
	},
	{
		"val": "MN Mongolsko Mongolsko",
		"nazev": "Mongolsko",
		"kod": "MN"
	},
	{
		"val": "MD Moldavska republika Moldavská republika",
		"nazev": "Moldavská republika",
		"kod": "MD"
	},
	{
		"val": "ME Cerna Hora Černá Hora",
		"nazev": "Černá Hora",
		"kod": "ME"
	},
	{
		"val": "MS Montserrat Montserrat",
		"nazev": "Montserrat",
		"kod": "MS"
	},
	{
		"val": "MA Maroko Maroko",
		"nazev": "Maroko",
		"kod": "MA"
	},
	{
		"val": "MZ Mosambik Mosambik",
		"nazev": "Mosambik",
		"kod": "MZ"
	},
	{
		"val": "OM Oman Omán",
		"nazev": "Omán",
		"kod": "OM"
	},
	{
		"val": "NA Namibie Namibie",
		"nazev": "Namibie",
		"kod": "NA"
	},
	{
		"val": "NR Nauru Nauru",
		"nazev": "Nauru",
		"kod": "NR"
	},
	{
		"val": "NP Nepal Nepál",
		"nazev": "Nepál",
		"kod": "NP"
	},
	{
		"val": "NL Nizozemsko Nizozemsko",
		"nazev": "Nizozemsko",
		"kod": "NL"
	},
	{
		"val": "CW Curacao Curaçao",
		"nazev": "Curaçao",
		"kod": "CW"
	},
	{
		"val": "AW Aruba Aruba",
		"nazev": "Aruba",
		"kod": "AW"
	},
	{
		"val": "SX Svaty Martin (nizozemska cast) Svatý Martin (nizozemská část)",
		"nazev": "Svatý Martin (nizozemská část)",
		"kod": "SX"
	},
	{
		"val": "BQ Bonaire, Svaty Eustach a Saba Bonaire, Svatý Eustach a Saba",
		"nazev": "Bonaire, Svatý Eustach a Saba",
		"kod": "BQ"
	},
	{
		"val": "NC Nova Kaledonie Nová Kaledonie",
		"nazev": "Nová Kaledonie",
		"kod": "NC"
	},
	{
		"val": "VU Vanuatu Vanuatu",
		"nazev": "Vanuatu",
		"kod": "VU"
	},
	{
		"val": "NZ Novy Zeland Nový Zéland",
		"nazev": "Nový Zéland",
		"kod": "NZ"
	},
	{
		"val": "NI Nikaragua Nikaragua",
		"nazev": "Nikaragua",
		"kod": "NI"
	},
	{
		"val": "NE Niger Niger",
		"nazev": "Niger",
		"kod": "NE"
	},
	{
		"val": "NG Nigerie Nigérie",
		"nazev": "Nigérie",
		"kod": "NG"
	},
	{
		"val": "NU Niue Niue",
		"nazev": "Niue",
		"kod": "NU"
	},
	{
		"val": "NF Ostrov Norfolk Ostrov Norfolk",
		"nazev": "Ostrov Norfolk",
		"kod": "NF"
	},
	{
		"val": "NO Norsko Norsko",
		"nazev": "Norsko",
		"kod": "NO"
	},
	{
		"val": "MP Ostrovy Severni Mariany Ostrovy Severní Mariany",
		"nazev": "Ostrovy Severní Mariany",
		"kod": "MP"
	},
	{
		"val": "UM Mensi odlehle ostrovy USA Menší odlehlé ostrovy USA",
		"nazev": "Menší odlehlé ostrovy USA",
		"kod": "UM"
	},
	{
		"val": "FM Mikronesie, federativni staty Mikronésie, federativní státy",
		"nazev": "Mikronésie, federativní státy",
		"kod": "FM"
	},
	{
		"val": "MH Marshallovy ostrovy Marshallovy ostrovy",
		"nazev": "Marshallovy ostrovy",
		"kod": "MH"
	},
	{
		"val": "PW Palau Palau",
		"nazev": "Palau",
		"kod": "PW"
	},
	{
		"val": "PK Pakistan Pákistán",
		"nazev": "Pákistán",
		"kod": "PK"
	},
	{
		"val": "PA Panama Panama",
		"nazev": "Panama",
		"kod": "PA"
	},
	{
		"val": "PG Papua Nova Guinea Papua Nová Guinea",
		"nazev": "Papua Nová Guinea",
		"kod": "PG"
	},
	{
		"val": "PY Paraguay Paraguay",
		"nazev": "Paraguay",
		"kod": "PY"
	},
	{
		"val": "PE Peru Peru",
		"nazev": "Peru",
		"kod": "PE"
	},
	{
		"val": "PH Filipiny Filipíny",
		"nazev": "Filipíny",
		"kod": "PH"
	},
	{
		"val": "PN Pitcairn Pitcairn",
		"nazev": "Pitcairn",
		"kod": "PN"
	},
	{
		"val": "PL Polsko Polsko",
		"nazev": "Polsko",
		"kod": "PL"
	},
	{
		"val": "PT Portugalsko Portugalsko",
		"nazev": "Portugalsko",
		"kod": "PT"
	},
	{
		"val": "GW Guinea-Bissau Guinea-Bissau",
		"nazev": "Guinea-Bissau",
		"kod": "GW"
	},
	{
		"val": "TL Vychodni Timor Východní Timor",
		"nazev": "Východní Timor",
		"kod": "TL"
	},
	{
		"val": "PR Portoriko Portoriko",
		"nazev": "Portoriko",
		"kod": "PR"
	},
	{
		"val": "QA Katar Katar",
		"nazev": "Katar",
		"kod": "QA"
	},
	{
		"val": "RE Reunion Réunion",
		"nazev": "Réunion",
		"kod": "RE"
	},
	{
		"val": "RO Rumunsko Rumunsko",
		"nazev": "Rumunsko",
		"kod": "RO"
	},
	{
		"val": "RU Ruska federace Ruská federace",
		"nazev": "Ruská federace",
		"kod": "RU"
	},
	{
		"val": "RW Rwanda Rwanda",
		"nazev": "Rwanda",
		"kod": "RW"
	},
	{
		"val": "BL Svaty Bartolomej Svatý Bartoloměj",
		"nazev": "Svatý Bartoloměj",
		"kod": "BL"
	},
	{
		"val": "SH Svata Helena, Ascension a Tristan da Cunha Svatá Helena, Ascension a Tristan da Cunha",
		"nazev": "Svatá Helena, Ascension a Tristan da Cunha",
		"kod": "SH"
	},
	{
		"val": "KN Svaty Krystof a Nevis Svatý Kryštof a Nevis",
		"nazev": "Svatý Kryštof a Nevis",
		"kod": "KN"
	},
	{
		"val": "AI Anguilla Anguilla",
		"nazev": "Anguilla",
		"kod": "AI"
	},
	{
		"val": "LC Svata Lucie Svatá Lucie",
		"nazev": "Svatá Lucie",
		"kod": "LC"
	},
	{
		"val": "MF Svaty Martin (francouzska cast) Svatý Martin (francouzská část)",
		"nazev": "Svatý Martin (francouzská část)",
		"kod": "MF"
	},
	{
		"val": "PM Saint Pierre a Miquelon Saint Pierre a Miquelon",
		"nazev": "Saint Pierre a Miquelon",
		"kod": "PM"
	},
	{
		"val": "VC Svaty Vincenc a Grenadiny Svatý Vincenc a Grenadiny",
		"nazev": "Svatý Vincenc a Grenadiny",
		"kod": "VC"
	},
	{
		"val": "SM San Marino San Marino",
		"nazev": "San Marino",
		"kod": "SM"
	},
	{
		"val": "ST Svaty Tomas a Princuv ostrov Svatý Tomáš a Princův ostrov",
		"nazev": "Svatý Tomáš a Princův ostrov",
		"kod": "ST"
	},
	{
		"val": "SA Saudska Arabie Saúdská Arábie",
		"nazev": "Saúdská Arábie",
		"kod": "SA"
	},
	{
		"val": "SN Senegal Senegal",
		"nazev": "Senegal",
		"kod": "SN"
	},
	{
		"val": "RS Srbsko Srbsko",
		"nazev": "Srbsko",
		"kod": "RS"
	},
	{
		"val": "SC Seychely Seychely",
		"nazev": "Seychely",
		"kod": "SC"
	},
	{
		"val": "SL Sierra Leone Sierra Leone",
		"nazev": "Sierra Leone",
		"kod": "SL"
	},
	{
		"val": "SG Singapur Singapur",
		"nazev": "Singapur",
		"kod": "SG"
	},
	{
		"val": "SK Slovensko Slovensko",
		"nazev": "Slovensko",
		"kod": "SK"
	},
	{
		"val": "VN Vietnam Vietnam",
		"nazev": "Vietnam",
		"kod": "VN"
	},
	{
		"val": "SS Jizni Sudan Jižní Súdán",
		"nazev": "Jižní Súdán",
		"kod": "SS"
	},
	{
		"val": "SI Slovinsko Slovinsko",
		"nazev": "Slovinsko",
		"kod": "SI"
	},
	{
		"val": "SO Somalsko Somálsko",
		"nazev": "Somálsko",
		"kod": "SO"
	},
	{
		"val": "ZA Jizni Afrika Jižní Afrika",
		"nazev": "Jižní Afrika",
		"kod": "ZA"
	},
	{
		"val": "ZW Zimbabwe Zimbabwe",
		"nazev": "Zimbabwe",
		"kod": "ZW"
	},
	{
		"val": "ES Spanelsko Španělsko",
		"nazev": "Španělsko",
		"kod": "ES"
	},
	{
		"val": "EH Zapadni Sahara Západní Sahara",
		"nazev": "Západní Sahara",
		"kod": "EH"
	},
	{
		"val": "SD Sudan Súdán",
		"nazev": "Súdán",
		"kod": "SD"
	},
	{
		"val": "SR Surinam Surinam",
		"nazev": "Surinam",
		"kod": "SR"
	},
	{
		"val": "SJ Svalbard a Jan Mayen Svalbard a Jan Mayen",
		"nazev": "Svalbard a Jan Mayen",
		"kod": "SJ"
	},
	{
		"val": "SZ Svazijsko Svazijsko",
		"nazev": "Svazijsko",
		"kod": "SZ"
	},
	{
		"val": "SE Svedsko Švédsko",
		"nazev": "Švédsko",
		"kod": "SE"
	},
	{
		"val": "CH Svycarsko Švýcarsko",
		"nazev": "Švýcarsko",
		"kod": "CH"
	},
	{
		"val": "SY Syrska arabska republika Syrská arabská republika",
		"nazev": "Syrská arabská republika",
		"kod": "SY"
	},
	{
		"val": "TJ Tadzikistan Tádžikistán",
		"nazev": "Tádžikistán",
		"kod": "TJ"
	},
	{
		"val": "TH Thajsko Thajsko",
		"nazev": "Thajsko",
		"kod": "TH"
	},
	{
		"val": "TG Togo Togo",
		"nazev": "Togo",
		"kod": "TG"
	},
	{
		"val": "TK Tokelau Tokelau",
		"nazev": "Tokelau",
		"kod": "TK"
	},
	{
		"val": "TO Tonga Tonga",
		"nazev": "Tonga",
		"kod": "TO"
	},
	{
		"val": "TT Trinidad a Tobago Trinidad a Tobago",
		"nazev": "Trinidad a Tobago",
		"kod": "TT"
	},
	{
		"val": "AE Spojene arabske emiraty Spojené arabské emiráty",
		"nazev": "Spojené arabské emiráty",
		"kod": "AE"
	},
	{
		"val": "TN Tunisko Tunisko",
		"nazev": "Tunisko",
		"kod": "TN"
	},
	{
		"val": "TR Turecko Turecko",
		"nazev": "Turecko",
		"kod": "TR"
	},
	{
		"val": "TM Turkmenistan Turkmenistán",
		"nazev": "Turkmenistán",
		"kod": "TM"
	},
	{
		"val": "TC Ostrovy Turks a Caicos Ostrovy Turks a Caicos",
		"nazev": "Ostrovy Turks a Caicos",
		"kod": "TC"
	},
	{
		"val": "TV Tuvalu Tuvalu",
		"nazev": "Tuvalu",
		"kod": "TV"
	},
	{
		"val": "UG Uganda Uganda",
		"nazev": "Uganda",
		"kod": "UG"
	},
	{
		"val": "UA Ukrajina Ukrajina",
		"nazev": "Ukrajina",
		"kod": "UA"
	},
	{
		"val": "MK Makedonie, byvala jugoslavska republika Makedonie, bývalá jugoslávská republika",
		"nazev": "Makedonie, bývalá jugoslávská republika",
		"kod": "MK"
	},
	{
		"val": "EG Egypt Egypt",
		"nazev": "Egypt",
		"kod": "EG"
	},
	{
		"val": "GB Spojene kralovstvi Spojené království",
		"nazev": "Spojené království",
		"kod": "GB"
	},
	{
		"val": "GG Guernsey Guernsey",
		"nazev": "Guernsey",
		"kod": "GG"
	},
	{
		"val": "JE Jersey Jersey",
		"nazev": "Jersey",
		"kod": "JE"
	},
	{
		"val": "IM Ostrov Man Ostrov Man",
		"nazev": "Ostrov Man",
		"kod": "IM"
	},
	{
		"val": "TZ Tanzanska sjednocena republika Tanzanská sjednocená republika",
		"nazev": "Tanzanská sjednocená republika",
		"kod": "TZ"
	},
	{
		"val": "US Spojene staty Spojené státy",
		"nazev": "Spojené státy",
		"kod": "US"
	},
	{
		"val": "VI Americke Panenske ostrovy Americké Panenské ostrovy",
		"nazev": "Americké Panenské ostrovy",
		"kod": "VI"
	},
	{
		"val": "BF Burkina Faso Burkina Faso",
		"nazev": "Burkina Faso",
		"kod": "BF"
	},
	{
		"val": "UY Uruguay Uruguay",
		"nazev": "Uruguay",
		"kod": "UY"
	},
	{
		"val": "UZ Uzbekistan Uzbekistán",
		"nazev": "Uzbekistán",
		"kod": "UZ"
	},
	{
		"val": "VE Bolivarovska republika Venezuela Bolívarovská republika Venezuela",
		"nazev": "Bolívarovská republika Venezuela",
		"kod": "VE"
	},
	{
		"val": "WF Wallis a Futuna Wallis a Futuna",
		"nazev": "Wallis a Futuna",
		"kod": "WF"
	},
	{
		"val": "WS Samoa Samoa",
		"nazev": "Samoa",
		"kod": "WS"
	},
	{
		"val": "YE Jemen Jemen",
		"nazev": "Jemen",
		"kod": "YE"
	},
	{
		"val": "ZM Zambie Zambie",
		"nazev": "Zambie",
		"kod": "ZM"
	},
	{
		"val": "AF Afghanistan Afghánistán",
		"nazev": "Afghánistán",
		"kod": "AF"
	},
	{
		"val": "AS Americka Samoa Americká Samoa",
		"nazev": "Americká Samoa",
		"kod": "AS"
	},
	{
		"val": "AU Australie Austrálie",
		"nazev": "Austrálie",
		"kod": "AU"
	},
	{
		"val": "BW Botswana Botswana",
		"nazev": "Botswana",
		"kod": "BW"
	},
	{
		"val": "IO Britske indickooceanske uzemi Britské indickooceánské území",
		"nazev": "Britské indickooceánské území",
		"kod": "IO"
	},
	{
		"val": "XK Kosovo Kosovo",
		"nazev": "Kosovo",
		"kod": "XK"
	},
	{
		"val": "BN Brunej Brunej",
		"nazev": "Brunej",
		"kod": "BN"
	},
	{
		"val": "BI Burundi Burundi",
		"nazev": "Burundi",
		"kod": "BI"
	},
	{
		"val": "LK Sri Lanka Šrí Lanka",
		"nazev": "Šrí Lanka",
		"kod": "LK"
	},
	{
		"val": "TW Tchaj-wan Tchaj-wan",
		"nazev": "Tchaj-wan",
		"kod": "TW"
	},
	{
		"val": "CX Vanocni ostrov Vánoční ostrov",
		"nazev": "Vánoční ostrov",
		"kod": "CX"
	},
	{
		"val": "CC Kokosove (Keelingovy) ostrovy Kokosové (Keelingovy) ostrovy",
		"nazev": "Kokosové (Keelingovy) ostrovy",
		"kod": "CC"
	},
	{
		"val": "YT Mayotte Mayotte",
		"nazev": "Mayotte",
		"kod": "YT"
	},
	{
		"val": "ER Eritrea Eritrea",
		"nazev": "Eritrea",
		"kod": "ER"
	},
	{
		"val": "FK Falklandy Falklandy",
		"nazev": "Falklandy",
		"kod": "FK"
	},
	{
		"val": "AX Alandy Alandy",
		"nazev": "Alandy",
		"kod": "AX"
	},
	{
		"val": "GF Francouzska Guyana Francouzská Guyana",
		"nazev": "Francouzská Guyana",
		"kod": "GF"
	},
	{
		"val": "TF Francouzska jizni a antarkticka uzemi Francouzská jižní a antarktická území",
		"nazev": "Francouzská jižní a antarktická území",
		"kod": "TF"
	},
	{
		"val": "PS Palestina Palestina",
		"nazev": "Palestina",
		"kod": "PS"
	},
	{
		"val": "GD Grenada Grenada",
		"nazev": "Grenada",
		"kod": "GD"
	},
	{
		"val": "GP Guadeloupe Guadeloupe",
		"nazev": "Guadeloupe",
		"kod": "GP"
	},
	{
		"val": "GU Guam Guam",
		"nazev": "Guam",
		"kod": "GU"
	},
	{
		"val": "GY Guyana Guyana",
		"nazev": "Guyana",
		"kod": "GY"
	},
	{
		"val": "HM Hearduv ostrov a MacDonaldovy ostrovy Heardův ostrov a MacDonaldovy ostrovy",
		"nazev": "Heardův ostrov a MacDonaldovy ostrovy",
		"kod": "HM"
	},
	{
		"val": "VA Vatikan Vatikán",
		"nazev": "Vatikán",
		"kod": "VA"
	},
	{
		"val": "HK Hongkong Hongkong",
		"nazev": "Hongkong",
		"kod": "HK"
	},
	{
		"val": "KW Kuvajt Kuvajt",
		"nazev": "Kuvajt",
		"kod": "KW"
	},
	{
		"val": "LS Lesotho Lesotho",
		"nazev": "Lesotho",
		"kod": "LS"
	},
	{
		"val": "LY Libye Libye",
		"nazev": "Libye",
		"kod": "LY"
	},
	{
		"val": "MO Macao Macao",
		"nazev": "Macao",
		"kod": "MO"
	},
	{
		"val": "MW Malawi Malawi",
		"nazev": "Malawi",
		"kod": "MW"
	},
	{
		"val": "MQ Martinik Martinik",
		"nazev": "Martinik",
		"kod": "MQ"
	},
	{
		"val": "NL Nizozemsko Nizozemsko",
		"nazev": "Nizozemsko",
		"kod": "NL"
	},
	{
		"val": "SX Svaty Martin (NL) Svatý Martin (NL)",
		"nazev": "Svatý Martin (NL)",
		"kod": "SX"
	},
	{
		"val": "NF Norfolk Norfolk",
		"nazev": "Norfolk",
		"kod": "NF"
	},
	{
		"val": "MP Severni Mariany Severní Mariany",
		"nazev": "Severní Mariany",
		"kod": "MP"
	},
	{
		"val": "PG Papua Nova Guinea Papua Nová Guinea",
		"nazev": "Papua Nová Guinea",
		"kod": "PG"
	},
	{
		"val": "PN Pitcairn Pitcairn",
		"nazev": "Pitcairn",
		"kod": "PN"
	},
	{
		"val": "PR Portoriko Portoriko",
		"nazev": "Portoriko",
		"kod": "PR"
	},
	{
		"val": "RE Reunion Réunion",
		"nazev": "Réunion",
		"kod": "RE"
	},
	{
		"val": "RW Rwanda Rwanda",
		"nazev": "Rwanda",
		"kod": "RW"
	},
	{
		"val": "BL Svaty Bartolomej Svatý Bartoloměj",
		"nazev": "Svatý Bartoloměj",
		"kod": "BL"
	},
	{
		"val": "KN Svaty Krystof a Nevis Svatý Kryštof a Nevis",
		"nazev": "Svatý Kryštof a Nevis",
		"kod": "KN"
	},
	{
		"val": "MF Svaty Martin (FR) Svatý Martin (FR)",
		"nazev": "Svatý Martin (FR)",
		"kod": "MF"
	},
	{
		"val": "PM Saint Pierre a Miquelon Saint Pierre a Miquelon",
		"nazev": "Saint Pierre a Miquelon",
		"kod": "PM"
	},
	{
		"val": "RS Srbsko Srbsko",
		"nazev": "Srbsko",
		"kod": "RS"
	},
	{
		"val": "SO Somalsko Somálsko",
		"nazev": "Somálsko",
		"kod": "SO"
	},
	{
		"val": "ZW Zimbabwe Zimbabwe",
		"nazev": "Zimbabwe",
		"kod": "ZW"
	},
	{
		"val": "EH Zapadni Sahara Západní Sahara",
		"nazev": "Západní Sahara",
		"kod": "EH"
	},
	{
		"val": "SJ Spicberky a Jan Mayen Špicberky a Jan Mayen",
		"nazev": "Špicberky a Jan Mayen",
		"kod": "SJ"
	},
	{
		"val": "TG Togo Togo",
		"nazev": "Togo",
		"kod": "TG"
	},
	{
		"val": "AE Spojene arabske emiraty Spojené arabské emiráty",
		"nazev": "Spojené arabské emiráty",
		"kod": "AE"
	},
	{
		"val": "GG Guernsey Guernsey",
		"nazev": "Guernsey",
		"kod": "GG"
	},
	{
		"val": "JE Jersey Jersey",
		"nazev": "Jersey",
		"kod": "JE"
	},
	{
		"val": "WF Wallis a Futuna Wallis a Futuna",
		"nazev": "Wallis a Futuna",
		"kod": "WF"
	},
	{
		"val": "BO Bolivie Bolívie",
		"nazev": "Bolívie",
		"kod": "BO"
	},
	{
		"val": "MM Myanmar Myanmar",
		"nazev": "Myanmar",
		"kod": "MM"
	},
	{
		"val": "CG Konzska republika Konžská republika",
		"nazev": "Konžská republika",
		"kod": "CG"
	},
	{
		"val": "CD Demokraticka republika Kongo Demokratická republika Kongo",
		"nazev": "Demokratická republika Kongo",
		"kod": "CD"
	},
	{
		"val": "IR Iran Írán",
		"nazev": "Írán",
		"kod": "IR"
	},
	{
		"val": "KP Korejska lidove demokraticka republika Korejská lidově demokratická republika",
		"nazev": "Korejská lidově demokratická republika",
		"kod": "KP"
	},
	{
		"val": "LA Laos Laos",
		"nazev": "Laos",
		"kod": "LA"
	},
	{
		"val": "MD Moldavsko Moldavsko",
		"nazev": "Moldavsko",
		"kod": "MD"
	},
	{
		"val": "FM Mikronesie Mikronésie",
		"nazev": "Mikronésie",
		"kod": "FM"
	},
	{
		"val": "RU Rusko Rusko",
		"nazev": "Rusko",
		"kod": "RU"
	},
	{
		"val": "SH Svata Helena Svatá Helena",
		"nazev": "Svatá Helena",
		"kod": "SH"
	},
	{
		"val": "SY Syrie Sýrie",
		"nazev": "Sýrie",
		"kod": "SY"
	},
	{
		"val": "TC Turks a Caicos Turks a Caicos",
		"nazev": "Turks a Caicos",
		"kod": "TC"
	},
	{
		"val": "MK Makedonie Makedonie",
		"nazev": "Makedonie",
		"kod": "MK"
	},
	{
		"val": "GB Velka Britanie Velká Británie",
		"nazev": "Velká Británie",
		"kod": "GB"
	},
	{
		"val": "IM Man Man",
		"nazev": "Man",
		"kod": "IM"
	},
	{
		"val": "TZ Tanzanie Tanzanie",
		"nazev": "Tanzanie",
		"kod": "TZ"
	},
	{
		"val": "VE Venezuela Venezuela",
		"nazev": "Venezuela",
		"kod": "VE"
	}
]


// WEBPACK FOOTER //
// build/services/countryDimensions/data.js